import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateTaskApiError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 230,
	height: 230,
	viewBox: "0 0 230 230",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6765_2975)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M112.154 214.099C166.323 214.099 210.236 170.187 210.236 116.018C210.236 61.8487 166.323 17.936 112.154 17.936C57.9853 17.936 14.0726 61.8487 14.0726 116.018C14.0726 170.187 57.9853 214.099 112.154 214.099Z",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.8911 66.0089L3.22039 76.6796C2.48211 77.4179 1.28796 77.4179 0.553721 76.6796C-0.18052 75.9414 -0.184555 74.7472 0.553721 74.013L11.2244 63.3423C11.9627 62.604 13.1568 62.604 13.8911 63.3423C14.6294 64.0806 14.6294 65.2747 13.8911 66.0089Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.8911 76.6757C13.1528 77.414 11.9586 77.414 11.2244 76.6757L0.553706 66.005C-0.184569 65.2668 -0.184569 64.0726 0.553706 63.3384C1.29198 62.6001 2.48613 62.6001 3.22037 63.3384L13.8911 74.0091C14.6293 74.7473 14.6293 75.9415 13.8911 76.6757Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M229.625 101.039L222.371 108.292C221.871 108.793 221.06 108.793 220.556 108.292C220.055 107.792 220.055 106.981 220.556 106.477L227.809 99.2233C228.31 98.7231 229.121 98.7231 229.625 99.2233C230.125 99.7236 230.125 100.534 229.625 101.039Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M229.625 108.296C229.124 108.797 228.314 108.797 227.809 108.296L220.556 101.043C220.055 100.542 220.055 99.7315 220.556 99.2272C221.056 98.727 221.867 98.727 222.371 99.2272L229.625 106.481C230.125 106.981 230.125 107.792 229.625 108.296Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M112.154 188.417C93.6087 188.417 75.059 181.357 60.939 167.237C32.699 138.997 32.699 93.0467 60.939 64.8026C89.179 36.5625 135.13 36.5625 163.37 64.8026C191.61 93.0426 191.61 138.993 163.37 167.237C149.25 181.357 130.7 188.417 112.154 188.417ZM65.4171 77.8212C46.0283 101.507 47.3797 136.609 69.4756 158.701C81.2396 170.465 96.699 176.351 112.154 176.351C125.722 176.351 139.281 171.82 150.355 162.755L65.4171 77.8172V77.8212ZM73.9536 69.2847L158.892 154.223C178.28 130.537 176.929 95.435 154.833 73.3432C132.737 51.2514 97.6389 49.8999 73.9536 69.2847Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.32476 145.654C5.84266 151.895 13.7499 154.098 19.9869 150.58L111.162 99.1749L103.561 94.358L107.567 85.9626L95.6904 86.1078L97.1145 77.3252L7.25062 127.996C1.01361 131.514 -1.18911 139.421 2.32476 145.654Z",
				fill: "#FFC700"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.0187 125.874L7.25062 127.996C1.01361 131.514 -1.18911 139.421 2.32476 145.654C5.84266 151.895 13.7499 154.098 19.9869 150.58L23.7509 148.458L11.0187 125.87V125.874Z",
				fill: "#FFCAC5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.4337 139.034L95.1215 95.7982C96.1624 95.2132 96.5295 93.894 95.9405 92.8532C95.3515 91.8164 94.0363 91.4492 92.9995 92.0342L16.3116 135.27L18.4337 139.034Z",
				fill: "#FFD84C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.0642 117.364L11.0065 125.856L23.7447 148.444L38.8024 139.953L26.0642 117.364Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.2688 141.494L29.3908 145.262C29.3908 145.262 29.3989 145.271 29.4029 145.279L33.1669 143.157C33.1669 143.157 33.1589 143.144 33.1548 143.136L31.0328 139.372C30.4478 138.332 29.1286 137.964 28.0918 138.553C27.0509 139.138 26.6838 140.458 27.2728 141.494H27.2688Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.5608 124.349L20.4388 120.581C20.4388 120.581 20.4307 120.573 20.4267 120.565L16.6627 122.687C16.6627 122.687 16.6707 122.699 16.6707 122.707L18.7968 126.471C19.3818 127.512 20.6969 127.879 21.7378 127.29C22.7786 126.705 23.1458 125.386 22.5568 124.349H22.5608Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M120.445 98.7432L210.038 153.069L227.85 148.704L223.485 130.896L133.996 76.6353L124.907 79.314L128.881 88.3589L120.489 90.368L120.445 98.7432Z",
				fill: "#FFC700"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M132.983 93.6882L206.416 138.215L209.098 137.557C209.28 137.513 209.445 137.396 209.518 137.226C209.942 136.25 209.591 135.088 208.655 134.519L135.222 89.9928C134.202 89.3756 132.874 89.6983 132.257 90.719C131.64 91.7397 131.963 93.067 132.983 93.6842V93.6882Z",
				fill: "#FFD84C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M210.038 153.069L227.85 148.704L223.485 130.896L210.038 153.069Z",
				fill: "#FFEEB2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M221.915 150.16L227.85 148.704L226.397 142.77L221.915 150.16Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M187.087 18.2913L204.084 48.3629C205.859 51.5016 203.592 55.3906 199.985 55.3906H166.399C162.813 55.3906 160.546 51.5459 162.276 48.4073L178.865 18.3357C180.645 15.1082 185.276 15.084 187.087 18.2913Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M182.875 43.0499C181.786 43.0499 180.903 42.1664 180.903 41.0772V27.8649C180.903 26.7756 181.786 25.8921 182.875 25.8921C183.965 25.8921 184.848 26.7756 184.848 27.8649V41.0772C184.848 42.1664 183.965 43.0499 182.875 43.0499Z",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M182.88 49.6986C182.355 49.6986 181.847 49.4888 181.484 49.1177C181.391 49.0249 181.31 48.924 181.238 48.8232C181.165 48.7143 181.104 48.6013 181.056 48.4803C181.008 48.3592 180.963 48.2382 180.943 48.1131C180.923 47.9881 180.907 47.8549 180.907 47.7258C180.907 47.5968 180.919 47.4677 180.943 47.3386C180.967 47.2175 181.012 47.0925 181.056 46.9714C181.104 46.8585 181.165 46.7415 181.238 46.6326C181.31 46.5236 181.395 46.4228 181.484 46.33C182.214 45.5998 183.537 45.5917 184.267 46.33C184.364 46.4187 184.441 46.5236 184.513 46.6326C184.586 46.7415 184.647 46.8544 184.695 46.9714C184.743 47.0925 184.784 47.2175 184.808 47.3386C184.832 47.4636 184.844 47.5968 184.844 47.7258C184.844 47.8549 184.832 47.984 184.808 48.1131C184.784 48.2422 184.739 48.3592 184.695 48.4803C184.647 48.6013 184.586 48.7143 184.513 48.8232C184.441 48.924 184.364 49.0289 184.267 49.1177C183.904 49.4848 183.396 49.6986 182.88 49.6986Z",
				fill: "#EBF3FF"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6765_2975",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 230,
			height: 230,
			fill: "white"
		})
	}) })]
});
export default SvgEmptyStateTaskApiError;
